<template>
  <v-card tile flat style="height: calc(100vh - 155px); overflow-y: scroll">
    <v-card-text class="pa-2">
      <v-tabs v-model="tabs" fixed-tabs v-show="config.webrtc">
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#mobile-tabs-5-2" class="primary--text">
          <v-icon>mdi-forum</v-icon>
        </v-tab>
        <v-tab href="#mobile-tabs-5-1" class="primary--text">
          <v-icon>mdi-phone</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item value="mobile-tabs-5-1">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="t('pesquisarAtendimentos')"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            mobile-breakpoint="300"
            :sort-by="orderby"
            :sort-desc="invert"
            :headers="headers"
            :items="historico"
            :locale="locale"
            :page.sync="pageCalls"
            hide-default-footer
            @page-count="pageCount = $event"
            :search="search"
            class="elevation-1 mt-4"
          >
            <template v-slot:item.dataini="{ item }">{{
              item.dataini | formatDate
            }}</template>
            <template v-slot:item.datafim="{ item }">{{
              duracao(item.dataini, item.datafim)
            }}</template>
            <template v-slot:item.sentido="{ item }">
              <v-icon :color="getStatus(item).color">{{
                getStatus(item).icon
              }}</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                @click="
                  clienteAux = { numero: item.numero };
                  modalLigacao = true;
                "
                >mdi-phone</v-icon
              >
            </template>
            <template v-slot:item.classificar="{ item }">
              <v-btn
                icon
                @click="
                  call = item;
                  atendimento = null;
                  modalClassificacao = true;
                "
                :disabled="!item.fila"
              >
                <v-icon>mdi-star</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-pagination v-model="pageCalls" :length="pageCount"></v-pagination>
        </v-tab-item>
        <v-tab-item value="mobile-tabs-5-2">
          <v-combobox
            v-model="searchAtendimentos"
            :items="
              config.webrtc
                ? [`${t('entrantes')}`, `${t('saintes')}`]
                : [`${t('entrantes')}`, `${t('saintes')}`]
            "
            chips
            :label="t('pesquisarAtendimentos')"
            append-icon="mdi-magnify"
          ></v-combobox>
          <v-data-table
            v-if="atendimentos"
            :sort-by="orderbyOmni"
            :sort-desc="invert"
            :headers="headersOmni"
            :items="atendimentos"
            :search="searchAtendimentos"
            :locale="locale"
            hide-default-footer
            :page.sync="pageAtendimentos"
            @page-count="pageCount = $event"
            class="elevation-1"
          >
            <template v-slot:item.queueTypeID="{ item }">
              <v-icon :color="getIcon(item).color">{{
                getIcon(item).icon
              }}</v-icon>
            </template>
            <template v-slot:item.fromID="{ item }">
              {{ item.fromID }}
            </template>
            <template v-slot:item.dataIni="{ item }">{{
              item.dataIni | formatDate
            }}</template>
            <template v-slot:item.sentido="{ item }">
              <v-icon :color="getStatus(item).color">{{
                getStatus(item).icon
              }}</v-icon>
            </template>
            <template v-slot:item.classificar="{ item }">
              <v-btn
                icon
                @click="
                  atendimento = item;
                  call = null;
                  modalClassificacao = true;
                "
              >
                <v-icon>mdi-star</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.ver="{ item }">
              <v-btn icon @click="viewAtendimento(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.ligar="{ item }">
              <v-btn
                icon
                @click="
                  clienteAux = { numero: item.fromID.split(`@`)[0] };
                  modalLigacao = true;
                "
                color="success"
              >
                <v-icon>mdi-phone</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-pagination
            v-model="pageAtendimentos"
            :length="pageCount"
          ></v-pagination>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <!-- MODAL CLASSIFICACAO -->
    <Classificar
      v-if="atendimento || call"
      :atendimento="atendimento"
      :queueTypeID="atendimento ? atendimento.queueTypeID : 1"
      :call="call"
      :open="modalClassificacao"
      v-on:updateClassificar:open="modalClassificacao = $event"
    />
    <!-- MODAL CLASSIFICACAO -->

    <b-modal
      id="modal-chat"
      title
      size="xl"
      scrollable
      centered
      style="max-height: 60vh; overflow-y: scroll"
    >
      <chat v-if="atendimento"></chat>
      <template v-slot:modal-footer>
        <button hidden></button>
      </template>
    </b-modal>
    <v-dialog v-model="modalLigacao" v-if="clienteAux">
      <Dial v-on:update="modalLigacao = $event" :numero="clienteAux.numero" />
    </v-dialog>
  </v-card>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import moment from "moment";
import chat from "../components/ChatH";
import Classificar from "./dialogs/Classificar";
import NovaLigacao from "./dialogs/NovaLigacao";
import Dial from "./Home";
let that = this;
//import DB from "../plugins/db";setAte

export default {
  name: "historico",
  components: {
    NovaLigacao,
    Classificar,
    chat,
    Dial,
  },
  props: {
    title: { type: String, default: "Title" },
  },
  data: () => ({
    call: {},
    config: JSON.parse(localStorage.getItem("config")),
    values: "",
    orderby: "calldate",
    orderbyOmni: "dataIni",
    invert: true,
    search: "",
    searchAtendimentos: "",
    tabs: null,
    pageAtendimentos: 0,
    pageCalls: 0,
    modalLigacao: false,
    clienteAux: null,
    headers: [],
    headersOmni: [],
    atendimento: null,
    call: null,
    modalClassificacao: false,
  }),

  computed: {
    ...mapState("sip", {
      historico: (state) => state.historico,
    }),
    ...mapState("xc", {
      atendimentos: (state) => state.atendimentosHistorico,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    locale() {
      let config = JSON.parse(localStorage.getItem(`config`));
      return config.idioma.split(`_`)[0];
    },
  },
  methods: {
    ...mapActions(`sip`, ["setHistorico", "ligar"]),
    ...mapActions(`xc`, [
      "getDefault",
      "setClassificacao",
      "getHistoricoAtendimentosAgente",
      "getHistoricoAtendimentosAgenteMin",
      "selectAtendimentoH",
    ]),
    getTranslate(text) {
      return this.$t(`${text}`);
    },
    async getHistorico() {
      let agentes = [];
      agentes.push(this.user.fullname);
      let calls = await this.getDefault(
        `/api/v2/filas/ligacoes?max=-1&page=1&agentes=${JSON.stringify(
          agentes
        )}`
      );
      calls.dados.map((a) => {
        if (a.sentido === 1) {
          a.sentido = `${this.t("entrantes")}`;
        } else {
          a.sentido = `${this.t("saintes")}`;
        }
      });
      console.log(`aquiiiii`, calls.dados);
      this.setHistorico(calls.dados);
    },
    closeModalLigacao() {
      this.modalLigacao = false;
    },
    viewAtendimento(item) {
      this.atendimento = item;
      this.selectAtendimentoH(this.atendimento);
      this.$bvModal.show(`modal-chat`);
    },
    duracao(d1, d2) {
      return moment.utc(moment(d2).diff(moment(d1))).format("HH:mm:ss");
    },
    getStatus(item) {
      if (item.sentido === `${this.t("entrantes")}` && !item.atendida)
        return { color: "red", icon: "mdi-phone-missed" };
      else if (item.sentido === `${this.t("saintes")}`)
        return { color: "indigo", icon: "mdi-phone-outgoing" };
      else return { color: "grey", icon: "mdi-phone-incoming" };
    },
    getIcon(item) {
      if (item.queueTypeID === 1) {
        return { color: "indigo", icon: "mdi-phone" };
      }
      if (item.queueTypeID === 3) {
        return { color: "#0DC143", icon: "mdi-whatsapp" };
      }
      if (item.queueTypeID === 5) {
        return { color: "#0DC143", icon: "mdi-whatsapp" };
      }
      if (item.queueTypeID === 4) {
        return { color: "#DB473A", icon: "mdi-gmail" };
      }
      if (item.queueTypeID === 2) {
        return { color: "indigo", icon: "mdi-chat" };
      }
      if (item.queueTypeID === 6) {
        return { color: "#0DC143", icon: "mdi-whatsapp" };
      }
      return { color: "#0DC143", icon: "mdi-whatsapp" };
    },
  },
  filters: {
    formatDate(value) {
      return moment(value).format("DD/MM HH:mm:ss");
    },
  },
  async created() {
    try {
      this.headers = [
        { text: `${this.t("data")}`, value: "dataini" },
        { text: `${this.t("numero")}`, value: "numero" },
        { text: `${this.t("nome")}`, value: "nome" },
        { text: `${this.t("duracao")}`, value: "datafim" },
        { text: `${this.t("status")}`, value: "sentido" },
        {
          text: `${this.t("ligar")}`,
          value: "actions",
          sortable: false,
          align: "end",
        },
        {
          text: `${this.t("classificar")}`,
          value: "classificar",
          sortable: false,
        },
        { text: `${this.t("classificacao")}`, value: "classificacao" },
        { text: `${this.t("subClassificacao")}`, value: "subclassificacao" },
        { text: `${this.t("obs")}`, value: "obs" },
      ];
      this.headersOmni = [
        { text: `${this.t("protocolo")}`, value: "id" },
        { text: `${this.t("tipo")}`, value: "queueTypeID" },
        { text: `${this.t("data")}`, value: "dataIni" },
        { text: `${this.t("numero")}`, value: "fromID" },
        { text: `${this.t("nome")}`, value: "fromName" },
        { text: `${this.t("sentido")}`, value: "sentido" },
        { text: `${this.t("fila")}`, value: "queue" },
        {
          text: `${this.t("classificar")}`,
          value: "classificar",
          sortable: false,
        },
        { text: `${this.t("classificacao")}`, value: "classificacao" },
        { text: `${this.t("subClassificacao")}`, value: "subclassificacao" },
        { text: `${this.t("obs")}`, value: "obs" },
        { text: `${this.t("visualizar")}`, value: "ver" },
        { text: `${this.t("ligar")}`, value: "ligar" },
      ];
      let aux = await this.getHistoricoAtendimentosAgente({
        agente: this.user.fullname,
      });
      aux.map((atendimento) => {
        if (atendimento.sentido)
          atendimento.sentido = this.t(`${atendimento.sentido.toLowerCase()}`);
      });
    } catch (error) {
      console.error(error);
    }
  },
};
</script>